var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-video"},[_c('video',{attrs:{"width":"320","height":"240","controls":""}},[_c('source',{attrs:{"src":_vm.src,"type":_vm.mediaType,"width":_vm.width}}),_vm._v(" Your browser does not support the video tag. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }